import { useState } from "react";
import { faqItems } from "@/mocks/siteContent";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-question-line text-xl text-secondary-600"></i>
          </div>
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-2">
            Got Questions?
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            AllChinaBuy Spreadsheet FAQ
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            Everything you need to know about using the AllChinaBuy Spreadsheet
          </p>
        </div>

        {/* FAQ Schema.org Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": faqItems.map((item) => ({
                "@type": "Question",
                "name": item.question,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": item.answer,
                },
              })),
            }),
          }}
        />

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => toggleFaq(idx)}
                aria-expanded={openIndex === idx}
              >
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <i
                    className={`text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === idx ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}